import { create } from "zustand";
import type { IOSAppId, IOSState } from "../types";

interface IOSStore extends IOSState {
  unlock: () => void;
  lock: () => void;
  openApp: (appId: IOSAppId) => void;
  closeApp: () => void;
  setDarkMode: (isDark: boolean) => void;
  setBrightness: (brightness: number) => void;
  setVolume: (volume: number) => void;
  toggleControlCenter: () => void;
  toggleNotificationCenter: () => void;
}

export const useIOSStore = create<IOSStore>((set) => ({
  // Initial state
  currentApp: null,
  isLocked: true,
  isDarkMode: true,
  brightness: 100,
  volume: 50,
  showControlCenter: false,
  showNotificationCenter: false,
  unlockedApps: ["photos", "messages", "voicememos", "notes"],

  // Actions
  unlock: () => set({ isLocked: false }),
  lock: () => set({ isLocked: true, currentApp: null }),
  openApp: (appId: IOSAppId) => set({ currentApp: appId }),
  closeApp: () => set({ currentApp: null }),
  setDarkMode: (isDark: boolean) => set({ isDarkMode: isDark }),
  setBrightness: (brightness: number) => set({ brightness }),
  setVolume: (volume: number) => set({ volume }),
  toggleControlCenter: () =>
    set((state) => ({ showControlCenter: !state.showControlCenter })),
  toggleNotificationCenter: () =>
    set((state) => ({ showNotificationCenter: !state.showNotificationCenter })),
}));